export default {"src":"/_next/static/media/ico_whatsapp.7fd6deaf.svg","height":18,"width":18};